<template>
<div class="selectmm">
  <div class="selectmm-title">请选择营销类型</div>
  <div class="selectmm-mode">
    <div class="selectmm-mode-market" @click="handleToForward('AddMarket')"></div>
    <div class="selectmm-mode-channel" @click="handleToForward('addchannel')"></div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
// import { post } from '../api/api'
import recordPageTime from '../mixin/minin'
export default {
  name: 'SelectMarketMode',
  methods: {
    handleToForward (tagetName) {
      this.$router.push({ name: tagetName, params: { routerName: this.$route.params.routerName } })
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.selectmm
  .selectmm-title
    margin-top : 150px
    text-align : center
    font-family: MyriadPro-Regular
    font-size: 38px
    font-weight: normal
    font-stretch: normal
  .selectmm-mode
    margin : 64px 8px 0 8px
    height : 650px
    display : flex
    justify-content : center
    align-items : center
    background-image : url("../assets/img/selectmarket.jpeg")
    background-repeat : no-repeat
    background-size : 100% 100%
    .selectmm-mode-channel
      flex : 1
      height : 100%
    .selectmm-mode-market
      flex : 1
      height : 100%
</style>
